export function rankedSearchMatches<T>(
  items: readonly T[],
  searchableText: (item: T) => Array<string | undefined>,
  query: string
): T[] {
  return items
    .map((item, index) => {
      let rank = Number.POSITIVE_INFINITY;
      for (const text of searchableText(item)) {
        const normalized = text?.toLowerCase();
        if (normalized === query) rank = Math.min(rank, 0);
        else if (normalized?.startsWith(query)) rank = Math.min(rank, 1);
        else if (normalized?.includes(query)) rank = Math.min(rank, 2);
      }
      return { item, index, rank };
    })
    .filter(({ rank }) => Number.isFinite(rank))
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .map(({ item }) => item);
}
